import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { NOTIFICATIONS, NotificationsService } from 'src/app/core/service/notifications.service';
import { PageType } from '../dto/types';
import { AuthBackendService } from '../../../auth/service/auth-backend.service';
import { environment } from "../../../../../environments/environment";
import { CaptchaV3Service } from "../../../../services/captcha/captcha-v3.service";
import {
  InvisibleRecaptchaComponent,
} from "../../../shared/component/captcha/invisible-recaptcha/invisible-recaptcha.component";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { ORCA_HELP_MAIL } from "../../../../../environments/urlService";
import { EMAIL_SESSION_STORAGE_KEY } from "../login.util";

@Component({
  selector: 'app-forgot-password-form',
  templateUrl: './forgot-password-form.component.html',
  styleUrls: [
    './forgot-password-form.component.scss',
    '../entrance-group.scss',
  ],
})
export class ForgotPasswordFormComponent {
  protected readonly ORCA_HELP_MAIL = ORCA_HELP_MAIL;

  @Output() newPageEvent = new EventEmitter<PageType>();
  captchaV2Token: string;

  @ViewChild('captcha')
  private captcha: InvisibleRecaptchaComponent;

  showCaptchaV2: boolean = false;
  siteV2Key: string = environment.recaptcha.siteKeyV2;

  form: FormGroup<{
    email: FormControl<string>;
  }>;

  constructor(
    private authService: AuthBackendService,
    private notificationsService: NotificationsService,
    private captchaService: CaptchaV3Service,
    private formBuilder: FormBuilder,
  ) {
    this.initForm();
  }

  changePage(page: PageType): void {
    this.newPageEvent.emit(page);
  }

  async onSubmit(): Promise<void> {
    if (!this.form.value.email) {
      this.notificationsService.error(NOTIFICATIONS.EMPTY_EMAIL_ERROR);
      return;
    }

    try {
      await this.captchaSubmit(this.form.value.email);
      this.notificationsService.success(NOTIFICATIONS.FORGOT_PASSWORD_SUCCESS);
      this.newPageEvent.emit('login');
    } catch (err) {
      this.showCaptchaV2 = true;
      if (this.captcha) {
        this.captcha.reset();
      }
      this.captchaV2Token = undefined;
    }
  }

  async captchaSubmit(email: string): Promise<void> {
    if (!environment.recaptcha.enable) {
      await this.authService.forgotPasswordCaptcha(email, null, null);
      return;
    }

    if (this.showCaptchaV2 && !this.captchaV2Token) {
      this.notificationsService.error(NOTIFICATIONS.CAPTCHA_NOT_RESOLVED_ERROR);
      return;
    }

    await this.captchaService.execute('login')
      .then((result) => {
        return this.authService.forgotPasswordCaptcha(email, this.captchaV2Token, result);
      });

  }

  onCaptchaResolved(token: string): void {
    this.captchaV2Token = token;
  }

  onCaptchaErrored(err: string): void {
    console.error(err);
  }

  private initForm(): void {
    this.form = this.formBuilder.group({
      email: new FormControl<string>(this.getEmailFromStorage(),
        { validators: [ Validators.email, Validators.maxLength(256), Validators.required ] }),
    });
  }

  private getEmailFromStorage(): string {
    const email = sessionStorage.getItem(EMAIL_SESSION_STORAGE_KEY) || '';
    sessionStorage.removeItem(EMAIL_SESSION_STORAGE_KEY);
    return email;
  }
}
